var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAntragWeiterleiten = function SvgAntragWeiterleiten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 160
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "931-a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a1343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c36a0"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 100c16.667-23.333 40-34 73.333-34v27.333L120 46.667 73.333 0v26.667C26.667 33.333 6.667 66.667 0 100Z",
    transform: "translate(40 30)",
    style: {
      fill: "url(#931-a)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(24 25.537)",
    style: {
      fill: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.062 30.599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 30.635 9.987 9.987L45.21 20l-5.271 5.271",
    transform: "translate(-2.486 -2.892)",
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.465,
    cy: 27.465,
    r: 27.465,
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h200v160H0z"
  }));
};
export default SvgAntragWeiterleiten;